<div id="rechnungenWbaSaldo">
  <div class="rechnungenWbaSaldoContent">
    <div>
      <strong>Kontenblattsaldo</strong>
    </div>
    <!--    Todo: hier muss dann das richtige command eingebunden werden-->
    <div>
      <span>xx.xx€</span>

    </div>
  </div>
</div>

<mat-accordion>
  <mat-expansion-panel *ngFor="let rechnung of rechnungen" class="rechnungenPanel">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <strong>
          {{rechnung.zeitraum[0] * 1000 | date:'dd.MM.YYYY'}} - {{rechnung.zeitraum[1] * 1000 | date:'dd.MM.YYYY'}}
        </strong>
        <span [ngClass]="rechnung.offen ? 'nichtBeglichen' : 'beglichen'" >Betrag: {{rechnung.betrag}}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div id="rechnungContent">
      <div class="rechnungContent">
        <div>
          <strong>Datum</strong>
          <span>{{rechnung.datum | date:'dd.MM.YYYY'}}</span>
        </div>
        <div>
          <strong>Nummer</strong>
          <span>{{rechnung.nr}}</span>
        </div>
        <div>
          <strong>Status der Rechnung</strong>
          <span [ngClass]="rechnung.offen ? 'nichtBeglichen' : 'beglichen'">{{ !rechnung.offen ? 'Betrag bezahlt' : 'Betrag offen'}}</span>
        </div>
      </div>
      <button (click)="rechnungAnfordern(rechnung.nr)">
        <mat-icon [matTooltip]="'Rechnung anfordern'" >mail</mat-icon>
        <span>Rechnung anfordern</span>
      </button>
    </div>
  </mat-expansion-panel>
</mat-accordion>
